"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = applyDecorators;
var defineProperty = Object.defineProperty;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

function applyDecorators(Class, props) {
  var prototype = Class.prototype;

  for (var key in props) {
    var decorators = props[key];

    for (var i = 0, l = decorators.length; i < l; i++) {
      var decorator = decorators[i];

      defineProperty(prototype, key, decorator(prototype, key, getOwnPropertyDescriptor(prototype, key)));
    }
  }

  return Class;
}

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/core-decorators/lib/applyDecorators.js
// module id = 543
// module chunks = 0 1 2